import { cn } from "@/lib/cn"
import { prizeArtSources, resolvePrizeArtKey } from "./prize-art"

type PrizeArtProps = {
  artKey?: string | null
  label: string
  size: number
  soft?: boolean
  className?: string
}

/** The natural-coloured 3D art of a prize, picked from the backend's `artKey` (label-based fallback when absent); `soft` is the smaller, faded, desaturated form used for a miss. */
export function PrizeArt({ artKey, label, size, soft = false, className }: PrizeArtProps) {
  const { src, srcSet } = prizeArtSources(soft ? "mystery-prize" : resolvePrizeArtKey(artKey, label))
  return (
    <img
      src={src}
      srcSet={srcSet}
      alt=""
      width={size}
      height={size}
      draggable={false}
      className={cn("shrink-0 object-contain", soft && "opacity-60 saturate-50", className)}
      style={{ width: size, height: size }}
    />
  )
}
